export default ({ request }) => ({
  fabricImageListApi(data) {
    return request({
      url: '/digitalCenter/fabric/Image/list',
      method: 'post',
      data,
    })
  },
  fabricImageSaveApi(data) {
    return request({
      url: '/digitalCenter/fabric/Image/save',
      method: 'post',
      data,
    })
  },
  fabricImageBatchAddApi(data) {
    return request({
      url: '/digitalCenter/fabric/Image/imageBatchAdd',
      method: 'post',
      data,
    })
  },
  fabricUpdateImageDescApi(data) {
    return request({
      url: '/digitalCenter/fabric/Image/updateImageDesc',
      method: 'post',
      data,
    })
  },
  fabricImageDelApi(data) {
    return request({
      url: '/digitalCenter/fabric/Image/del',
      method: 'post',
      data,
    })
  },
})
